import { keyframes as t, css as s } from "../stitches.config.es.js";
const a = t({
  "0%": {
    opacity: 0,
    transform: "translateY(2px)"
  },
  "100%": {
    opacity: 1,
    transform: "translateY(0)"
  }
}), e = t({
  "0%": {
    opacity: 0,
    transform: "translateX(-2px)"
  },
  "100%": {
    opacity: 1,
    transform: "translateX(0)"
  }
}), o = t({
  "0%": {
    opacity: 0,
    transform: "translateY(-2px)"
  },
  "100%": {
    opacity: 1,
    transform: "translateY(0)"
  }
}), i = t({
  "0%": {
    opacity: 0,
    transform: "translateX(2px)"
  },
  "100%": {
    opacity: 1,
    transform: "translateX(0)"
  }
}), n = s({
  zIndex: "$$zIndex",
  fontFamily: "$default",
  fontWeight: "$regular",
  position: "relative",
  border: "1px $coreGreys100main solid",
  borderRadius: 5,
  padding: "$xs $sm",
  fontSize: "$small",
  background: "$coreGreys150",
  color: "$genericWhite",
  animationDuration: "400ms",
  animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
  animationFillMode: "forwards",
  willChange: "transform, opacity",
  '&[data-state="delayed-open"]': {
    '&[data-side="top"]': {
      animationName: o
    },
    '&[data-side="right"]': {
      animationName: i
    },
    '&[data-side="bottom"]': {
      animationName: a
    },
    '&[data-side="left"]': {
      animationName: e
    }
  },
  '&[data-state="instant-open"]': {
    display: "none"
  },
  "&::after": {
    content: "",
    display: "block",
    position: "absolute",
    width: 0,
    height: 0
  },
  '&[data-position="top"]': {
    "&::after": {
      bottom: "-$sizes$sm",
      left: "calc(50% - $sizes$sm)",
      borderLeft: "$sizes$sm solid transparent",
      borderRight: "$sizes$sm solid transparent",
      borderTop: "$sizes$sm solid $coreGreys100main"
    }
  },
  '&[data-position="left"]': {
    "&::after": {
      right: "-$sizes$sm",
      top: "calc(50% - $sizes$sm)",
      borderTop: "$sizes$sm solid transparent",
      borderBottom: "$sizes$sm solid transparent",
      borderLeft: "$sizes$sm solid $coreGreys100main"
    }
  },
  '&[data-position="right"]': {
    "&::after": {
      left: "-$sizes$sm",
      top: "calc(50% - $sizes$sm)",
      borderTop: "$sizes$sm solid transparent",
      borderBottom: "$sizes$sm solid transparent",
      borderRight: "$sizes$sm solid $coreGreys100main"
    }
  },
  '&[data-position="bottom"]': {
    "&::after": {
      top: "-$sizes$sm",
      left: "calc(50% - $sizes$sm)",
      borderLeft: "$sizes$sm solid transparent",
      borderRight: "$sizes$sm solid transparent",
      borderBottom: "$sizes$sm solid $coreGreys100main"
    }
  },
  variants: {
    noArrow: {
      true: {
        "&::after": {
          display: "none"
        }
      }
    },
    customFont: {
      small: {
        fontSize: "$xsmall"
      },
      medium: {
        fontsize: "$small"
      }
    }
  }
});
export {
  n as tooltipContentStyles
};
//# sourceMappingURL=Tooltip.styles.es.js.map
